import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const ResumeDescription = ({ des }) => {
  const { t } = useTranslation();

  if (!des || !Array.isArray(des)) return null;

  return (
    <div className="flex flex-col gap-5">
      {des.map((item, index) => {
        if (item.type === 'title') {
          return (
            <h4
              key={index}
              className="text-designColor font-semibold text-base md:text-lg mt-2"
            >
              {t(item.value)}
            </h4>
          );
        }

        return (
          <div
            key={index}
            className="flex items-start gap-3 text-gray-300 leading-relaxed"
          >
            <span className="mt-[10px] min-w-[6px] h-[6px] rounded-full bg-designColor" />

            <p className="text-sm md:text-base">
              {t(item.value)}
            </p>
          </div>
        );
      })}
    </div>
  );
};

const ResumeCard = ({ title, subTitle, result, des }) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreenSize();

    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  return (
    <div className="w-full group flex transition duration-500">
      {/* Timeline */}
      <div className="w-5 md:w-10 flex-shrink-0 relative">
        <div className="bgOpacity mt-16 h-[6px] w-full">
          <span
            className={`absolute w-5 h-5 rounded-full -top-2 ${
              isRTL ? '-right-3' : '-left-3'
            } flex justify-center items-center bg-[#1f1f1f] border border-white/10`}
          >
            <span
              className={`w-3 h-3 rounded-full inline-flex duration-300 ${
                isMobile
                  ? 'bg-designColor'
                  : 'bg-gray-500 group-hover:bg-designColor'
              }`}
            />
          </span>
        </div>
      </div>

      {/* Card */}
      <div
        className={`
          w-full
          rounded-2xl
          border
          border-white/5
          bg-gradient-to-br
          from-[#111111]
          to-[#191919]
          p-5
          md:p-8
          flex
          flex-col
          gap-8
          shadow-xl
          transition-all
          duration-300
          hover:border-designColor/20
          hover:-translate-y-1
        `}
      >
        {/* Header */}
        <div className="flex flex-col lg:flex-row justify-between gap-5 lg:items-center">
          <div className="space-y-2">
            <h3 className="text-xl md:text-2xl font-bold text-white leading-snug">
              {t(title)}
            </h3>

            <p className="text-gray-400 text-sm md:text-base">
              {t(subTitle)}
            </p>
          </div>

          <div>
            <div
              className="
                px-5
                py-2.5
                rounded-xl
                bg-designColor/10
                border
                border-designColor/20
                text-designColor
                text-sm
                font-medium
                whitespace-nowrap
              "
            >
              {t(result)}
            </div>
          </div>
        </div>

        {/* Content */}
        <div>
          <ResumeDescription des={des} />
        </div>
      </div>
    </div>
  );
};

export default ResumeCard;